// extracted by mini-css-extract-plugin
export default {"swiperContainer":"swiperContainer__1mavJ","swiperSlide":"swiperSlide__3P31E","productSlideImg":"productSlideImg__3i5G8","swiperPaginationBulletActive":"swiperPaginationBulletActive__2KMh8"};
    if(module.hot) {
      // 1788784382059
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  